import React from 'react';
import { Form, Card, DatePicker } from 'antd';
import { AntdButton, InputField, SelectInput } from '../../../blueplanitUtils/InputField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { USER_ISSUES, ISSUE_STATUS, LEAD_INFORMATION, PRIORITY } from "../../../Dropdownmanager";
import { getOptionsByPath } from "../../../utilsdata";
import { useSelector } from 'react-redux';
import { useEffect } from "react";
import { getEmployeesListThunk } from "../../../Slices/Thunk/getemployeelist";
import { useDispatch } from "react-redux";
 
 
const AdminTaskFilter = ({ showFilters, onClose, onSearch, onClear, form }) => {
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
 
 
    const dispatch = useDispatch();
 
    const employees = useSelector(
          (state) => state.employee.AllEmployees || []
        );
 
    const employeesOptions =
    employees.map((emp) => ({
      label: `${emp.firstname} ${emp.lastname}`,
      value: `${emp.firstname} ${emp.lastname}`,
    })) || [];
 
    // useEffect(() => {
    //     dispatch(getEmployeesListThunk());
    // }, [dispatch]);
 
 
    if (!showFilters) return null;
 
    return (
        <Card
            style={{
                backgroundColor: '#f9f9f9',
                borderRadius: 8,
                marginLeft: '20px',
                marginTop: '-40px',
 
            }}
        >
            <FontAwesomeIcon
                icon={faTimes}
                onClick={onClose}
                style={{
                    position: 'absolute',
                    top: 10,
                    right: 26,
                    fontSize: 14,
                    cursor: 'pointer',
                    color: '#333'
                }}
            />
 
            <div
                style={{
                    maxHeight: 'calc(100vh - 120px)',
                    overflowY: 'auto',
                    paddingRight: 8,
                    marginTop: 6
                }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSearch}
                >
                    <Form.Item
                        name="taskID"
                        label="Task ID"
                        style={{ marginBottom: 10 }}
                    >
                        <InputField placeholder="Search by task title" />
                    </Form.Item>
                    <Form.Item
                        name="taskTitle"
                        label="Task Title"
                        style={{ marginBottom: 10 }}
                    >
                        <InputField placeholder="Search by task title" />
                    </Form.Item>
 
                    <Form.Item
                        name="createdBy"
                        label="Created By"
                        style={{ marginBottom: -10 }}
                    >
                        <SelectInput
                            allowClear
                            showSearch
                            optionFilterProp="label"
                            placeholder="Select Created By"
                            options={employeesOptions}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
 
                        />
 
                    </Form.Item>
                    <Form.Item
                        name="guidedBy"
                        label="Guided By"
                        style={{ marginBottom: -10}}
                    >
                        <SelectInput
                            allowClear
                            showSearch
                            optionFilterProp="label"
                            placeholder="Select Guide"
                            options={employeesOptions}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                        />
 
                    </Form.Item>
                    <Form.Item
                        name="deadlinefrom"
                        label="Deadline From"
                        style={{ marginBottom: 10 }}
                    >
                        <DatePicker style={{ width: '100%' }} format="DD-MM-YYYY" />
                    </Form.Item>
 
                    <Form.Item
                        name="deadlineto"
                        label="Deadline To"
                        style={{ marginBottom: 10 }}
                    >
                        <DatePicker style={{ width: '100%' }} format="DD-MM-YYYY" />
                    </Form.Item>
 
                    <Form.Item
                        name="status"
                        label="Task Status"
                        style={{ marginBottom: -10}}
                    >
                        <SelectInput
                            allowClear
                            placeholder="Select Status"
                            mode="multiple"
                            options={getOptionsByPath(NestedDatabucket, [USER_ISSUES, ISSUE_STATUS])}
                        />
                    </Form.Item>
                    <Form.Item
                        name="Priority"
                        label="Priority"
                        style={{ marginBottom: -10 }}
                    >
                        <SelectInput
                            allowClear
                            placeholder="Select Priority"
                            options={getOptionsByPath(NestedDatabucket, [LEAD_INFORMATION, PRIORITY])}
                        />
                    </Form.Item>
 
 
                    <Form.Item
                        name="AssignedTo"
                        label="Assigned To"
                        style={{ marginBottom: 0 }}
                    >
                        <SelectInput
                            allowClear
                            showSearch
                            optionFilterProp="label"
                            mode="multiple"
                            placeholder="Select Assignee"
                            options={employeesOptions}
                            filterOption={(input, option) =>
                                option.label.toLowerCase().includes(input.toLowerCase())
                            }
                        />
 
                    </Form.Item>
 
                    <Form.Item
                        name="createdDateFrom"
                        label="Created From Date"
                        style={{ marginBottom: 10 }}
                    >
                        <DatePicker style={{ width: '100%' }} format="DD-MM-YYYY" />
                    </Form.Item>
 
                    <Form.Item
                        name="createdDateTo"
                        label="Created To Date"
                        style={{ marginBottom: 10 }}
                    >
                        <DatePicker style={{ width: '100%' }} format="DD-MM-YYYY" />
                    </Form.Item>
                    <div
                        style={{
                            marginBottom: '10px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: 40,
                        }}
                    >
                        <div style={{ display: 'flex', gap: '8px', marginBottom: 10 }}>
                            <AntdButton type="primary" htmlType="submit" label="Search" />
                            <AntdButton
                                onClick={onClear}
                                style={{ backgroundColor: '#6c757d', color: '#fff', border: 'none' }}
                                label="Clear"
                            />
                        </div>
                    </div>
                </Form>
            </div>
        </Card>
    );
};
 
export default AdminTaskFilter;